<div class="status-tiles-container" #statusTiles>
    <ul *ngIf="currentStatusType == statusTypes.QUOTE">
        <li class="col" *ngFor="let tile of tiles; let first = first; let last = last;" [class.selected]="tile.quoteStatus.statusName === quoteSelectedTile">
            <div class="tile-container">
                <div class="tile" [ngClass]="tile.colorTheme" (click)="emitTileClick(tile)">
                    <span class="tile-heading" *ngIf="currentStatusType == statusTypes.QUOTE">{{ tile.quoteStatus.statusName }}</span>                    
                    <span class="tile-sub-heading" [vsStatusCounter]="tile.statusCount || 0">
                        <span class="counter-number">0</span>
                        
                    </span>
                </div>
            </div>
        </li>
    </ul>

    <ul *ngIf="currentStatusType == statusTypes.ORDER">
        <li class="col" *ngFor="let tile of tiles; let first = first; let last = last;"  [class.selected]="tile.orderStatus.statusName === selectedTile">
            <div class="tile-container">
                <div class="tile" [ngClass]="tile.colorTheme" (click)="emitTileClick(tile)">
                    <span class="tile-heading"
                        matTooltipClass="vs-tooltip capitalize" matTooltip="{{tile.tooltip}}" matTooltipPosition="below"
                        >{{ tile.orderStatus.statusName }}</span>
                    <span class="tile-sub-heading" [vsStatusCounter]="tile.statusCount || 0">
                        <span class="counter-number">0</span>
                        
                    </span>
                </div>
            </div>
        </li>
    </ul>
</div>

<!-- [appCounter]="statusService.rmaStatus[header.var] || 0" -->